/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  ExportSloveniaVodXmlBody,
  ExportSloveniaYearlyNormiraniReportBody,
  GenerateKirExportParams,
  GetSloveniaTaxProfile200,
  ReviewSloveniaYearlyNormiraniReport200,
  ReviewSloveniaYearlyNormiraniReportBody,
  UpdateSloveniaTaxProfile200,
  UpdateSloveniaTaxProfileBody
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * 
Generate a KIR (Knjiga izdanih računov / Evidenca obračunanega DDV) export file for FURS.

This export contains all issued invoices and credit notes for the specified period in FURS-compliant XML format,
packaged in a ZIP archive ready for upload to eDavki.

**Period Selection:**
- Use `month` for monthly exports (e.g., month=1 for January)
- Use `quarter` for quarterly exports (e.g., quarter=1 for Q1)
- Cannot use both month and quarter

**Transaction Type Mapping:**
- Domestic sales → P7 (taxable supplies) + P14/P15/P16 (VAT by rate)
- Intra-EU B2B → P10 (reverse charge)
- Intra-EU B2C → P7 + P14/P15/P16 (standard VAT)
- Export (third country) → P27 (export exemption)

**Credit Notes:**
- Included with negative amounts as per FURS specification
- Same field mapping as invoices, but amounts are negated

**Important:**
- Voided documents are included with zero amounts
- Entity must have a valid Slovenian tax number (SI prefix is automatically removed)

 * @summary Generate KIR export (Issued Invoices Ledger)
 */
export type generateKirExportResponse200 = {
  data: Blob
  status: 200
}

export type generateKirExportResponse400 = {
  data: Error
  status: 400
}

export type generateKirExportResponse401 = {
  data: Error
  status: 401
}

export type generateKirExportResponse403 = {
  data: Error
  status: 403
}

export type generateKirExportResponse404 = {
  data: Error
  status: 404
}

export type generateKirExportResponse500 = {
  data: Error
  status: 500
}

export type generateKirExportResponseSuccess = (generateKirExportResponse200) & {
  headers: Headers;
};
export type generateKirExportResponseError = (generateKirExportResponse400 | generateKirExportResponse401 | generateKirExportResponse403 | generateKirExportResponse404 | generateKirExportResponse500) & {
  headers: Headers;
};

export type generateKirExportResponse = (generateKirExportResponseSuccess | generateKirExportResponseError)

export const getGenerateKirExportUrl = (params: GenerateKirExportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tax-reports/kir?${stringifiedParams}` : `/tax-reports/kir`
}

export const generateKirExport = async (params: GenerateKirExportParams, options?: RequestInit): Promise<generateKirExportResponse> => {
  
  return customFetch<generateKirExportResponse>(getGenerateKirExportUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * Retrieve the normalized Slovenia-specific tax profile stored on the entity, including inferred business form and yearly-export support status.
 * @summary Get Slovenia yearly tax profile
 */
export type getSloveniaTaxProfileResponse200 = {
  data: GetSloveniaTaxProfile200
  status: 200
}

export type getSloveniaTaxProfileResponse400 = {
  data: Error
  status: 400
}

export type getSloveniaTaxProfileResponse401 = {
  data: Error
  status: 401
}

export type getSloveniaTaxProfileResponse403 = {
  data: Error
  status: 403
}

export type getSloveniaTaxProfileResponse404 = {
  data: Error
  status: 404
}

export type getSloveniaTaxProfileResponse500 = {
  data: Error
  status: 500
}

export type getSloveniaTaxProfileResponseSuccess = (getSloveniaTaxProfileResponse200) & {
  headers: Headers;
};
export type getSloveniaTaxProfileResponseError = (getSloveniaTaxProfileResponse400 | getSloveniaTaxProfileResponse401 | getSloveniaTaxProfileResponse403 | getSloveniaTaxProfileResponse404 | getSloveniaTaxProfileResponse500) & {
  headers: Headers;
};

export type getSloveniaTaxProfileResponse = (getSloveniaTaxProfileResponseSuccess | getSloveniaTaxProfileResponseError)

export const getGetSloveniaTaxProfileUrl = () => {


  

  return `/tax-reports/si/profile`
}

export const getSloveniaTaxProfile = async ( options?: RequestInit): Promise<getSloveniaTaxProfileResponse> => {
  
  return customFetch<getSloveniaTaxProfileResponse>(getGetSloveniaTaxProfileUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update the Slovenia-specific tax profile stored on the entity. Unsupported profiles are stored for future use but remain blocked for yearly export.
 * @summary Update Slovenia yearly tax profile
 */
export type updateSloveniaTaxProfileResponse200 = {
  data: UpdateSloveniaTaxProfile200
  status: 200
}

export type updateSloveniaTaxProfileResponse400 = {
  data: Error
  status: 400
}

export type updateSloveniaTaxProfileResponse401 = {
  data: Error
  status: 401
}

export type updateSloveniaTaxProfileResponse403 = {
  data: Error
  status: 403
}

export type updateSloveniaTaxProfileResponse404 = {
  data: Error
  status: 404
}

export type updateSloveniaTaxProfileResponse500 = {
  data: Error
  status: 500
}

export type updateSloveniaTaxProfileResponseSuccess = (updateSloveniaTaxProfileResponse200) & {
  headers: Headers;
};
export type updateSloveniaTaxProfileResponseError = (updateSloveniaTaxProfileResponse400 | updateSloveniaTaxProfileResponse401 | updateSloveniaTaxProfileResponse403 | updateSloveniaTaxProfileResponse404 | updateSloveniaTaxProfileResponse500) & {
  headers: Headers;
};

export type updateSloveniaTaxProfileResponse = (updateSloveniaTaxProfileResponseSuccess | updateSloveniaTaxProfileResponseError)

export const getUpdateSloveniaTaxProfileUrl = () => {


  

  return `/tax-reports/si/profile`
}

export const updateSloveniaTaxProfile = async (updateSloveniaTaxProfileBody: UpdateSloveniaTaxProfileBody, options?: RequestInit): Promise<updateSloveniaTaxProfileResponse> => {
  
  return customFetch<updateSloveniaTaxProfileResponse>(getUpdateSloveniaTaxProfileUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateSloveniaTaxProfileBody,)
  }
);}
  

/**
 * Build a review draft for the yearly Slovenia DDD-DDD filing for the supported resident normirani s.p. path.
 * @summary Review yearly Slovenia normirani filing
 */
export type reviewSloveniaYearlyNormiraniReportResponse200 = {
  data: ReviewSloveniaYearlyNormiraniReport200
  status: 200
}

export type reviewSloveniaYearlyNormiraniReportResponse400 = {
  data: Error
  status: 400
}

export type reviewSloveniaYearlyNormiraniReportResponse401 = {
  data: Error
  status: 401
}

export type reviewSloveniaYearlyNormiraniReportResponse403 = {
  data: Error
  status: 403
}

export type reviewSloveniaYearlyNormiraniReportResponse404 = {
  data: Error
  status: 404
}

export type reviewSloveniaYearlyNormiraniReportResponse500 = {
  data: Error
  status: 500
}

export type reviewSloveniaYearlyNormiraniReportResponseSuccess = (reviewSloveniaYearlyNormiraniReportResponse200) & {
  headers: Headers;
};
export type reviewSloveniaYearlyNormiraniReportResponseError = (reviewSloveniaYearlyNormiraniReportResponse400 | reviewSloveniaYearlyNormiraniReportResponse401 | reviewSloveniaYearlyNormiraniReportResponse403 | reviewSloveniaYearlyNormiraniReportResponse404 | reviewSloveniaYearlyNormiraniReportResponse500) & {
  headers: Headers;
};

export type reviewSloveniaYearlyNormiraniReportResponse = (reviewSloveniaYearlyNormiraniReportResponseSuccess | reviewSloveniaYearlyNormiraniReportResponseError)

export const getReviewSloveniaYearlyNormiraniReportUrl = () => {


  

  return `/tax-reports/si/yearly/normirani/review`
}

export const reviewSloveniaYearlyNormiraniReport = async (reviewSloveniaYearlyNormiraniReportBody: ReviewSloveniaYearlyNormiraniReportBody, options?: RequestInit): Promise<reviewSloveniaYearlyNormiraniReportResponse> => {
  
  return customFetch<reviewSloveniaYearlyNormiraniReportResponse>(getReviewSloveniaYearlyNormiraniReportUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reviewSloveniaYearlyNormiraniReportBody,)
  }
);}
  

/**
 * Generate a DDD-DDD XML file for the supported resident normirani s.p. path after the yearly review values are confirmed.
 * @summary Export yearly Slovenia normirani XML
 */
export type exportSloveniaYearlyNormiraniReportResponse200 = {
  data: Blob
  status: 200
}

export type exportSloveniaYearlyNormiraniReportResponse400 = {
  data: Error
  status: 400
}

export type exportSloveniaYearlyNormiraniReportResponse401 = {
  data: Error
  status: 401
}

export type exportSloveniaYearlyNormiraniReportResponse403 = {
  data: Error
  status: 403
}

export type exportSloveniaYearlyNormiraniReportResponse404 = {
  data: Error
  status: 404
}

export type exportSloveniaYearlyNormiraniReportResponse500 = {
  data: Error
  status: 500
}

export type exportSloveniaYearlyNormiraniReportResponseSuccess = (exportSloveniaYearlyNormiraniReportResponse200) & {
  headers: Headers;
};
export type exportSloveniaYearlyNormiraniReportResponseError = (exportSloveniaYearlyNormiraniReportResponse400 | exportSloveniaYearlyNormiraniReportResponse401 | exportSloveniaYearlyNormiraniReportResponse403 | exportSloveniaYearlyNormiraniReportResponse404 | exportSloveniaYearlyNormiraniReportResponse500) & {
  headers: Headers;
};

export type exportSloveniaYearlyNormiraniReportResponse = (exportSloveniaYearlyNormiraniReportResponseSuccess | exportSloveniaYearlyNormiraniReportResponseError)

export const getExportSloveniaYearlyNormiraniReportUrl = () => {


  

  return `/tax-reports/si/yearly/normirani/export`
}

export const exportSloveniaYearlyNormiraniReport = async (exportSloveniaYearlyNormiraniReportBody: ExportSloveniaYearlyNormiraniReportBody, options?: RequestInit): Promise<exportSloveniaYearlyNormiraniReportResponse> => {
  
  return customFetch<exportSloveniaYearlyNormiraniReportResponse>(getExportSloveniaYearlyNormiraniReportUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      exportSloveniaYearlyNormiraniReportBody,)
  }
);}
  

/**
 * Generate a legacy-compatible Slovenian VOD ZIP export for issued documents. The first release contains only VOD_izdani.xml.
 * @summary Export Slovenia VOD XML ZIP
 */
export type exportSloveniaVodXmlResponse200 = {
  data: Blob
  status: 200
}

export type exportSloveniaVodXmlResponse400 = {
  data: Error
  status: 400
}

export type exportSloveniaVodXmlResponse401 = {
  data: Error
  status: 401
}

export type exportSloveniaVodXmlResponse403 = {
  data: Error
  status: 403
}

export type exportSloveniaVodXmlResponse404 = {
  data: Error
  status: 404
}

export type exportSloveniaVodXmlResponse500 = {
  data: Error
  status: 500
}

export type exportSloveniaVodXmlResponseSuccess = (exportSloveniaVodXmlResponse200) & {
  headers: Headers;
};
export type exportSloveniaVodXmlResponseError = (exportSloveniaVodXmlResponse400 | exportSloveniaVodXmlResponse401 | exportSloveniaVodXmlResponse403 | exportSloveniaVodXmlResponse404 | exportSloveniaVodXmlResponse500) & {
  headers: Headers;
};

export type exportSloveniaVodXmlResponse = (exportSloveniaVodXmlResponseSuccess | exportSloveniaVodXmlResponseError)

export const getExportSloveniaVodXmlUrl = () => {


  

  return `/tax-reports/si/accounting/vod/export`
}

export const exportSloveniaVodXml = async (exportSloveniaVodXmlBody: ExportSloveniaVodXmlBody, options?: RequestInit): Promise<exportSloveniaVodXmlResponse> => {
  
  return customFetch<exportSloveniaVodXmlResponse>(getExportSloveniaVodXmlUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      exportSloveniaVodXmlBody,)
  }
);}
  

